import React from "react";
import { Link } from "react-router-dom";
import "../styles/Research1.css";
import "../styles/Navbar.css";

import headerborder from "../assets/images/bordder-line.svg";

import researchimage from "../assets/images/research-1.svg";
import researchimage2 from "../assets/images/research-2.svg";
import fullreport from "../assets/images/full-report-icon.svg";

import reasearchcardborder from "../assets/images/research-card-border.svg";
import content4 from "../assets/images/content4.svg";
import analytics3 from "../assets/images/analytics-44.png";
import analytics2 from "../assets/images/analytics-442.png";
import tangoLogo from "../assets/logos/Tango.png";

const Research4 = () => {
    // Asset paths from src/assets folder


    return (
        <div className="research-page">
            {/* Research Content */}
            <div className="Research1-container">
                <div className="research-heading-container">
                    <img src={headerborder} alt="headerborder" className="headerborder" />
                    <div className="research-content-wrapper">
                        <div className="inner-research">
                            <div className="research-header-content">
                                <div>
                                    <p className="research-heading">
                                        USDA McGovern-Dole Grant: Home Grown School
                                    </p>
                                    <p className="research-heading">
                                        Feeding Program - Phase II Midterm Evaluation
                                    </p>
                                </div>
                                <img src={tangoLogo} alt="Tango Logo" className="tango-logo" />
                            </div>
                            <p className="date">July - December 2023</p>
                            <p className="partnership">
                                Partnership: IHEMA Research Team & USDA
                            </p>
                            <p className="research-role-detail">
                                <span className="role-label">IHEMA's Role:</span>
                                <span className="role-badge">Data Collection &amp; Reporting</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="content-container">
                    <p className="content-paragraph">
                        Building on its collaboration with TANGO International, IHEMA Research Team led the midterm evaluation of Phase II of Rwanda’s Home Grown School Feeding Program, funded by the USDA McGovern-Dole International Food for Education and Child Nutrition Program. The evaluation assessed implementation progress and early outcomes of a nationally significant initiative linking nutrition, education, and local agricultural development.
                    </p>
                    <p className="content-paragraph">
                        The evaluation covered 54 schools across multiple districts and applied a rigorous mixed-methods approach. IHEMA Research Team managed all field implementation activities, including evaluator training, coordination across geographically diverse sites, and quality assurance for large-scale data collection. A comprehensive training program was delivered to enumerators, with specialized modules on Early Grade Reading Assessment (EGRA), standardized survey protocols, and ethical engagement with children and school communities.
                    </p>
                    <p className="content-paragraph">
                        A central component of the evaluation was the administration of EGRA literacy assessments to Primary 2 learners. Enumerators were trained in child-sensitive assessment techniques and strict adherence to international EGRA standards to ensure reliability and comparability of results. The assessment generated robust evidence on literacy outcomes and contributed to understanding the relationship between school feeding and learning performance.
                    </p>
                    <p className="content-paragraph">
                        In parallel, IHEMA implemented quantitative school surveys using customized ODK tools designed with validation rules and skip logic to enhance data accuracy and completeness. These surveys captured detailed information on program implementation, attendance patterns, school infrastructure, and teacher observations. Real-time monitoring enabled rapid resolution of data quality issues during fieldwork.
                    </p>
                    <p className="content-paragraph">
                        Throughout the evaluation, IHEMA Research Team provided translation and cultural adaptation support for all data collection tools, ensuring linguistic accuracy and contextual relevance while maintaining methodological rigor. This work strengthened the validity of findings and supported evidence-based recommendations to inform program adjustments and future scale-up.
                    </p>
                    <img src={content4} alt="content" className="content-image" />
                    <div className="analytics">
                        <img src={analytics3} alt="Analytics" className="analytics" />
                        <img src={analytics2} alt="Analytics" className="analytics" />
                    </div>
                </div>
                <div className="research-card-container">
                    <img src={reasearchcardborder} alt="headerborder" className="research-card-border" />
                    <div className="outer-container">
                        <p className="more-assessments">More Assessments</p>
                        <div className="cards-container">
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        USDA McGovern-Dole Grant: Home Grown School Feeding Program -
                                        Phase II Endline & Phase III Baseline
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mcgovern-dole" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        Rapid review of the Mastercard Foundation COVID-19 Recovery
                                        and Resilience Program (CRRP Rwanda)
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage2}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mastercard-foundation" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        Impact study of World Vision Rwanda programs focusing on
                                        community development and educational initiatives
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src="https://res.cloudinary.com/dsxiw1bop/image/upload/v1770284459/research-3_pu8jhx.svg"
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/world-vision" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Research4;
